import dayjs from 'dayjs'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'srcReact/components/common2/Button'
import DataPill from 'srcReact/components/common2/DataPill'
import Icon from 'srcReact/components/icons/Icon'
import {
  formatLastUpdateDate,
  getCustomDateFormat,
  getDateFormat9,
  getTimeFormat1
} from 'srcReact/helpers/datetimeHelper'
import WidgetContainer from '../WidgetContainer'
import styles from './styles.module.scss'
import { appConstantSettings } from 'srcReact/appConstantSettings'

function ThisMixr({
  startDateTime,
  endDateTime,
  duration,
  address,
  timezone,
  joinLink,
  longitude,
  latitude,
  isMixrNotOver,
  handleAddToCalendar
}) {
  const { t } = useTranslation()

  const getDuration = () => {
    const { days, hours, minutes } = duration
    if (days === 0) {
      if (hours === 0) {
        return t('widgets.thisMixr.minutes', { count: duration.minutes })
      } else {
        if (minutes === 0) {
          return t('widgets.thisMixr.hours', { count: duration.hours })
        } else {
          return `${t('widgets.thisMixr.hours', { count: duration.hours })} ${t('widgets.thisMixr.minutes', {
            count: duration.minutes
          })}`
        }
      }
    } else if (days < 3) {
      if (hours === 0) {
        return t('global.dayAgo', { count: duration.days })
      } else {
        return `${t('global.dayAgo', { count: duration.days })} ${t('widgets.thisMixr.hours', {
          count: duration.hours
        })}`
      }
    } else {
      return t('global.dayAgo', { count: duration.days })
    }
  }

  return (
    <WidgetContainer title={t('widgets.thisMixr.title')}>
      <div className={styles.thisMixrContainer}>
        <p className={styles.duration}>
          {`${t('widgets.thisMixr.duration')}: `}
          {getDuration()}
        </p>
        <div className={styles.datetime}>
          {/* <span className={styles.date}> {formatLastUpdateDate(startDateTime, getDateFormat9())}</span> */}
          <span
            className={styles.date}
            dangerouslySetInnerHTML={{
              __html: getCustomDateFormat(startDateTime, endDateTime, '', t, appConstantSettings.DATE_FORMAT5)
            }}
          />
          <span className={styles.time}>
            {`${dayjs(startDateTime).format(getTimeFormat1())} - ${dayjs(endDateTime).format(getTimeFormat1())}`}{' '}
            <span>{timezone}</span>
          </span>
        </div>
        {address && (
          <DataPill
            type='address'
            renderIcon={() => <Icon name='map24' size='large24' />}
            text={address}
            longitude={longitude}
            latitude={latitude}
            className={styles.address}
          />
        )}
        {joinLink && (
          <DataPill
            type='link'
            renderIcon={() => <Icon name='link' size='large24' />}
            text={joinLink}
            className={styles.address}
          />
        )}
        {isMixrNotOver && (
          <Button
            text={t('mixrHome.addToCalendar')}
            customStyle={styles.calendarBtn}
            size='medium'
            iconPosition='start'
            icon={<Icon name='create-mixr' size='large24' />}
            handleClick={handleAddToCalendar}
          />
        )}
      </div>
    </WidgetContainer>
  )
}

export default ThisMixr
